import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportUsersCollaborations_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportUsersCollaborations extends Report<ReportUsersCollaborations_Settings> {

    static reportName   : string = "Collaboration"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_USERS_COLLABORATIONS
        super(data);

        this.icon           = "isvg-collaboration"
        this.name           = data.name || "Collaboration"
        this.description    = "Provides insights into team collaboration through key metrics."

        this.settings       = new ReportUsersCollaborations_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportUsersCollaborations {
        return new ReportUsersCollaborations(savedView.toReportConfig());
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportUsersCollaborations_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)
    }
}
